import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=4e1bc824&scoped=true&"
var script = {}
import style0 from "./choice.vue?vue&type=style&index=0&id=4e1bc824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1bc824",
  null
  
)

export default component.exports